__turbopack_context__.v({
  "desktop-megamenu": "hMqh4q_desktop-megamenu",
  "desktop-megamenu-inner": "hMqh4q_desktop-megamenu-inner",
  "desktop-megamenu-list": "hMqh4q_desktop-megamenu-list",
});
